import { render, staticRenderFns } from "./WaveDiagnostics.vue?vue&type=template&id=84b279de&scoped=true&"
import script from "./WaveDiagnostics.vue?vue&type=script&lang=js&"
export * from "./WaveDiagnostics.vue?vue&type=script&lang=js&"
import style0 from "./WaveDiagnostics.vue?vue&type=style&index=0&id=84b279de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b279de",
  null
  
)

export default component.exports